const DAY_INPUT = /^(\d{4})-(\d{2})-\d{2}$/;

const positiveOrNull = (months: number): number | null =>
  Number.isInteger(months) && months >= 1 ? months : null;

/**
 * Number of months between the first and last repayment instalments, from two
 * "yyyy-MM-dd" date input values: 12 × (last year − first year) + (last month − first month).
 * Null when an input is empty or invalid, or when the result is below 1.
 */
export const monthsBetweenDates = (
  first: string,
  last: string
): number | null => {
  const firstMatch = DAY_INPUT.exec(first);
  const lastMatch = DAY_INPUT.exec(last);
  if (!firstMatch || !lastMatch) return null;

  const months =
    12 * (Number(lastMatch[1]) - Number(firstMatch[1])) +
    (Number(lastMatch[2]) - Number(firstMatch[2]));
  return positiveOrNull(months);
};

/**
 * Number of months covered by the instalments from `first` to `last`, both included.
 * Null when an input is empty, or when the result is below 1.
 */
export const monthsBetweenInstalments = (
  first: number | '',
  last: number | ''
): number | null => {
  if (first === '' || last === '') return null;
  return positiveOrNull(last - first + 1);
};
